export default "__VITE_ASSET__l4Imhz57__"